import React from 'react';
import './services.css';
import { Helmet } from "react-helmet";

import whatsapp from '../../Assets/whatsapp.png';
import call from '../../Assets/call.png';
import TripleFlatPiercingImage from '../../Assets/Piercing Services/triple flat piercing.png';
import Footer from '../contactus/contactus';

const handleWhatsAppClick = (message) => {
  const url = `https://wa.me/971567257579?text=${encodeURIComponent(message)}`;
  window.open(url, "_blank");
};

function TripleFlatPiercing() {
  return (
    <div>
      <div className="earlobe-container">
        <Helmet>
          <title>Triple Flat Piercing UAE | 350 AED</title>
        </Helmet>

        <div className="floating-buttons">
          <div
            className='whatsapp-button'
            onClick={() => handleWhatsAppClick("I am interested in Triple Flat Piercing")}
          >
            <img src={whatsapp} alt="WhatsApp" />
          </div>

          <a href="tel:+971567257579" className="call-button">
            <img src={call} alt="Call" />
          </a>
        </div>

        <h1 className="earlobe-title">
          Triple Flat Piercing 350 AED
        </h1>

        <div className="earlobe-image-wrapper">
          <img src={TripleFlatPiercingImage} alt="Triple Flat Piercing" />
        </div>

        <div className="earlobe-content">
          <h3>Triple Flat Piercing</h3>

          <p>
            Upgrade your ear styling with our professional triple flat piercing services in the UAE, available at an affordable price of 350 AED. Triple flat piercing is a bold and contemporary cartilage piercing style that features three precisely placed piercings on the flat area of the upper ear, creating a layered and modern look that instantly stands out. Perfect for individuals who want to express their personality with confidence, this piercing style offers a unique combination of elegance and edge. Whether you prefer minimal studs for a clean aesthetic or a mix of statement jewelry for a more dramatic effect, our expert specialists ensure accurate placement and alignment for a visually balanced and stunning result.
          </p>

          <p>
            At our piercing studio, safety, hygiene, and comfort are our highest priorities. Our certified professionals use sterile, single-use, high-quality equipment to perform each triple flat piercing with precision and care. We strictly follow professional hygiene protocols to maintain a clean and sanitized environment, minimizing the risk of infection and ensuring a safe and smooth experience. Since this service involves multiple cartilage piercings, our experienced specialists use advanced techniques to reduce discomfort and make the procedure as quick and efficient as possible.
          </p>

          <p>
            Triple flat piercing is ideal for those who want a bold and fashionable ear design that reflects a modern sense of style. The flat area of the ear provides ample space for creativity, making it perfect for layering multiple pieces of jewelry and experimenting with different arrangements. This piercing pairs beautifully with other ear styles such as helix, conch, tragus, or lobe, allowing you to create a fully customized and curated ear look. Our specialists take the time to understand your preferences and provide personalized guidance on placement and jewelry options to suit your ear structure and desired aesthetic.
          </p>

          <p>
            The procedure is typically completed within a short time, even with three piercings, making it convenient for clients with busy schedules. We also provide high-quality, hypoallergenic starter jewelry that is safe for sensitive skin, helping to prevent irritation and ensuring a smooth healing process. Our goal is to deliver not only a stylish result but also a comfortable and safe experience from start to finish.
          </p>

          <p>
            Our clean, welcoming, and professional environment ensures that every client feels relaxed and confident throughout their visit. We understand that multiple cartilage piercings can feel intimidating, especially for first-time clients, and our friendly staff is always available to answer your questions and provide reassurance. From consultation to completion, we focus on delivering a positive and stress-free experience tailored to your needs.
          </p>

          <p>
            Aftercare is especially important for triple flat piercings, and we provide detailed instructions to help you maintain proper care during the healing period. Our specialists will guide you on cleaning routines, recommended products, and precautions to avoid infection or irritation. With proper aftercare, your triple flat piercing will heal effectively and remain a stylish and long-lasting feature of your ear design.
          </p>

          <p>
            Our triple flat piercing services in the UAE combine affordability with premium quality, offering transparent pricing with no hidden costs. Booking your appointment is quick and convenient, allowing you to choose a time that suits your schedule. We aim to provide minimal waiting time and a seamless experience from start to finish.
          </p>

          <p>
            Choose our trusted triple flat piercing services in the UAE for a safe, hygienic, and professional experience. With experienced specialists, precise techniques, and a strong focus on customer satisfaction, we help you achieve a bold and modern layered look effortlessly. Book your triple flat piercing appointment today and elevate your ear styling with confidence and expert care.
          </p>

          <button
            className="book-btn"
            onClick={() => handleWhatsAppClick("I want to book Triple Flat Piercing")}
          >
            Book Now
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default TripleFlatPiercing;